// Users
export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const SEND_USER_INFO = 'SEND_USER_INFO';
export const SEND_USER_INFO_SUCCESS = 'SEND_USER_INFO_SUCCESS';
export const SEND_USER_INFO_FAILURE = 'SEND_USER_INFO_FAILURE';
export const SEND_PART_USER_INFO_SUCCESS = 'SEND_PART_USER_INFO_SUCCESS';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';
export const DELETE_SELECTED_LANGUAGE = 'DELETE_SELECTED_LANGUAGE';
export const DELETE_SELECTED_LANGUAGE_SUCCESS =
  'DELETE_SELECTED_LANGUAGE_SUCCESS';
export const SELECT_SUBCATEGORY = 'SELECT_SUBCATEGORY';
export const DELETE_SELECTED_SUBCATEGORY = 'DELETE_SELECTED_SUBCATEGORY';
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO';
export const RECEIVE_USER_INFO_SUCCESS = 'RECEIVE_USER_INFO_SUCCESS';
export const RECEIVE_USER_INFO_FAILURE = 'RECEIVE_USER_INFO_FAILURE';
export const GET_SENDED_INFO = 'GET_SENDED_INFO';
export const LOGOUT = 'LOGOUT';
export const REQUEST_USER = 'REQUEST_USER';
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const CHANGE_LANGUAGE_FAILURE = 'CHANGE_LANGUAGE_FAILURE';
export const RECEIVE_USER = 'RECEIVE_USER';
export const NOT_RECEIVE_USER = 'NOT_RECEIVE_USER';
export const PARTNER_APPLY = 'PARTNER_APPLY';
export const SEND_USER = 'SEND_USER';
export const USER_ADD_ERROR = 'USER_ADD_ERROR';
export const USER_REMOVE_ERRORS = 'USER_REMOVE_ERRORS';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';
export const UNHIJACK = 'UNHIJACK';
export const UPLOAD_AVATAR = 'UPLOAD_AVATAR';
export const UPLOAD_AVATAR_SUCCESS = 'UPLOAD_AVATAR_SUCCESS';
export const UPLOAD_AVATAR_FAILURE = 'UPLOAD_AVATAR_FAILURE';
export const USER_RESET_ERRORS = 'USER_RESET_ERRORS';
export const USER_CLICK_LOGIN = 'USER_CLICK_LOGIN';
export const REQUEST_PAYOUT = 'REQUEST_PAYOUT';
export const REQUEST_PAYOUT_SUCCESS = 'REQUEST_PAYOUT_SUCCESS';

// Partner
export const FETCH_PARTNER_DATA = 'FETCH_PARTNER_DATA';
export const FETCH_PARTNER_DATA_SUCCESS = 'FETCH_PARTNER_DATA_SUCCESS';
export const FETCH_PARTNER_DATA_FAILURE = 'FETCH_PARTNER_DATA_FAILURE';
export const UPDATE_PARTNER_DATA = 'UPDATE_PARTNER_DATA';
export const UPDATE_PARTNER_DATA_SUCCESS = 'UPDATE_PARTNER_DATA_SUCCESS';
export const UPDATE_PARTNER_DATA_FAILURE = 'UPDATE_PARTNER_DATA_FAILURE';
export const UPDATE_REQUISITES = 'UPDATE_REQUISITES';
export const UPDATE_REQUISITES_SUCCESS = 'UPDATE_REQUISITES_SUCCESS';
export const UPDATE_REQUISITES_FAILURE = 'UPDATE_REQUISITES_FAILURE';
export const ADD_REQUISITES = 'ADD_REQUISITES';
export const ADD_REQUISITES_SUCCESS = 'ADD_REQUISITES_SUCCESS';
export const ADD_REQUISITES_FAILURE = 'ADD_REQUISITES_FAILURE';
export const OPEN_FORM_BIO_POPUP = 'OPEN_FORM_BIO_POPUP';
export const CLOSE_FORM_BIO_POPUP = 'CLOSE_FORM_BIO_POPUP';
export const FETCH_AFFILIATE_PARTNER = 'FETCH_AFFILIATE_PARTNER';
export const FETCH_AFFILIATE_PARTNER_SUCCESS =
  'FETCH_AFFILIATE_PARTNER_SUCCESS';
export const FETCH_AFFILIATE_PARTNER_FAILURE =
  'FETCH_AFFILIATE_PARTNER_FAILURE';
export const UPDATE_AFFILIATE_PARTNER = 'UPDATE_AFFILIATE_PARTNER';
export const UPDATE_AFFILIATE_PARTNER_SUCCESS =
  'UPDATE_AFFILIATE_PARTNER_SUCCESS';
export const UPDATE_AFFILIATE_PARTNER_FAILURE =
  'UPDATE_AFFILIATE_PARTNER_FAILURE';

// Referal & Codes
export const FETCH_ANALYTICS_ORDERS = 'FETCH_ANALYTICS_ORDERS';
export const FETCH_ANALYTICS_ORDERS_SUCCESS = 'FETCH_ANALYTICS_ORDERS_SUCCESS';
export const FETCH_ANALYTICS_ORDERS_FAILURE = 'FETCH_ANALYTICS_ORDERS_FAILURE';
export const FETCH_ANALYTICS_SUMMARY = 'FETCH_ANALYTICS_SUMMARY';
export const FETCH_ANALYTICS_SUMMARY_SUCCESS =
  'FETCH_ANALYTICS_SUMMARY_SUCCESS';
export const FETCH_ANALYTICS_SUMMARY_FAILURE =
  'FETCH_ANALYTICS_SUMMARY_FAILURE';
export const FETCH_ANALYTICS_PRODUCTS = 'FETCH_ANALYTICS_PRODUCTS';
export const FETCH_ANALYTICS_PRODUCTS_SUCCESS =
  'FETCH_ANALYTICS_PRODUCTS_SUCCESS';
export const FETCH_ANALYTICS_PRODUCTS_FAILURE =
  'FETCH_ANALYTICS_PRODUCTS_FAILURE';
export const RESET_REFERAL_ERRORS = 'RESET_REFERAL_ERRORS';

export const CREATE_CODES = 'CREATE_CODES';
export const CREATE_CODES_SUCCESS = 'CREATE_CODES_SUCCESS';
export const CREATE_CODES_FAILURE = 'CREATE_CODES_FAILURE';
export const FETCH_CODES = 'FETCH_CODES';
export const FETCH_CODES_SUCCESS = 'FETCH_CODES_SUCCESS';
export const FETCH_CODES_FAILURE = 'FETCH_CODES_FAILURE';
export const UPDATE_CODE = 'UPDATE_CODE';
export const UPDATE_CODE_SUCCESS = 'UPDATE_CODE_SUCCESS';
export const UPDATE_CODE_FAILURE = 'UPDATE_CODE_FAILURE';
export const ADD_RECENT_CODES = 'ADD_RECENT_CODES';
export const REMOVE_RECENT_CODES = 'REMOVE_RECENT_CODES';
